import { routes } from 'commons/constants/routes'
import { formatCurrency } from 'commons/utils'
import { DateTime } from 'ui/components/DateTime'
import { IconName, IconSize } from 'ui/components/Icon'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'
import { SarItem } from '~bank-bsa-reporting/types'

import * as SC from './styles'

export const columns = ({
  onItemSelect,
  onDelete,
  onShowWarnings,
  chosenItems,
  isAllItemsChosen
}: {
  onItemSelect: (item?: SarItem) => void
  onDelete: (item: SarItem) => void
  onShowWarnings: (data: string) => void
  chosenItems: SarItem[]
  isAllItemsChosen: boolean
}): TableColumn<SarItem>[] => [
  {
    title: (
      <SC.WrappedCheckBox
        checkBoxLabel=""
        value={isAllItemsChosen}
        onChange={() => onItemSelect()}
        data-qa="SARs List all checkbox"
      />
    ),
    sortable: false,
    width: '50px',
    align: 'center',
    dataQa: (v: string) => `title_${v}`,
    render: (item) => (
      <SC.WrappedCheckBox
        checkBoxLabel=""
        value={chosenItems.findIndex((i) => i.id === item.id) !== -1}
        onChange={() => onItemSelect(item)}
        data-qa={`SARs List item checkbox ${item.id}`}
      />
    )
  },
  {
    title: 'ID',
    align: 'center',
    render: ({ id }) => (
      <Link to="/bsa/sars/$id" params={{ id: id.toString() }}>
        {id}
      </Link>
    )
  },
  {
    title: 'Period',
    align: 'center',
    render: ({ periodStart, periodEnd }) => `${periodStart} - ${periodEnd}`
  },
  {
    title: 'Relationship',
    align: 'center',
    render: ({ relationship }) => (
      <Link to={routes.bank.relationships.details} params={{ id: relationship?.id.toString() }}>
        {relationship?.name || ''}
      </Link>
    )
  },
  {
    title: 'Total',
    align: 'center',
    render: ({ total }) => formatCurrency(total)
  },
  {
    title: 'Status',
    align: 'center',
    render: ({ id, status, attention }) => (
      <SC.NameRow key={'status' + id}>
        {attention?.length > 0 && (
          <SC.WarnIcon name={IconName.ERROR_RED} size={IconSize.XS} onClick={() => onShowWarnings(attention)} />
        )}
        {status}
      </SC.NameRow>
    )
  },
  {
    title: 'Created Date',
    align: 'center',
    render: ({ createdAt }) => <DateTime date={createdAt} withTime />
  },
  {
    title: 'Last Modified Date',
    align: 'center',
    render: ({ lastModifiedAt }) => <DateTime date={lastModifiedAt} withTime />
  },
  {
    title: 'Action',
    align: 'center',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `/bsa/sars/${item.id}/edit`
          },
          {
            type: 'delete',
            onClick: () => onDelete(item)
          }
        ]}
      />
    )
  }
]
